module.exports = __webpack_public_path__ + "static/img/user.7e58fe70.jpg";